import { isColumnId } from './report-entity-selection.utils';

// Custom Taxonomy Constants and Helpers
export enum HIDDEN_REPORT_FIELDS {
  CUSTOM_TAXONOMY = 'custom_taxonomy',
  CUSTOM_TAXONOMY_VERSION = 'custom_taxonomy_version',
  SKILL_TAXONOMY_VERSION = 'skill_taxonomy_version',
  SKILL_TAXONOMY_NAME = 'skill_taxonomy_name',
}

export const isHiddenColumn = (column: { id?: string; label?: string }) => {
  return (
    isColumnId(HIDDEN_REPORT_FIELDS.CUSTOM_TAXONOMY, column) ||
    isColumnId(HIDDEN_REPORT_FIELDS.CUSTOM_TAXONOMY_VERSION, column) ||
    isColumnId(HIDDEN_REPORT_FIELDS.SKILL_TAXONOMY_VERSION, column) ||
    isColumnId(HIDDEN_REPORT_FIELDS.SKILL_TAXONOMY_NAME, column)
  );
};
